module.exports = __webpack_public_path__ + "static/template_stride_v2-f296faba38851613aa2a265ba17fb03f.png";